<!-- START: icons/fontawesome -->
<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>FontAwesome</strong>
            <a href="http://fontawesome.io/" target="_blank" class="btn btn-sm btn-primary ml-2">Official Documentation <i class="icmn-link ml-1"><!-- --></i></a>
        </span>
    </div>
    <div class="card-block">
        <div class="row">
            <div class="col-lg-12">
                <h5 class="text-black"><strong>The iconic font</strong></h5>
                <p class="text-muted">
                    The complete set of 634 icons in Font Awesome 4.6.3
                    <br>
                    License: MIT License. You can use it for commercial projects, open source projects, or really just about whatever you want
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 offset-xl-3">
                <ul class="cat__core__icons-block list-unstyled">
                    <h3 class="text-block mt-5 mb-4"><strong>New Icons in 4.6</strong></h3>
                    <li><i class="fa fa-american-sign-language-interpreting"></i></li>
                    <li><i class="fa fa-asl-interpreting"></i></li>
                    <li><i class="fa fa-assistive-listening-systems"></i></li>
                    <li><i class="fa fa-blind"></i></li>
                    <li><i class="fa fa-braille"></i></li>
                    <li><i class="fa fa-deaf"></i></li>
                    <li><i class="fa fa-deafness"></i></li>
                    <li><i class="fa fa-envira"></i></li>
                    <li><i class="fa fa-fa"></i></li>
                    <li><i class="fa fa-first-order"></i></li>
                    <li><i class="fa fa-font-awesome"></i></li>
                    <li><i class="fa fa-gitlab"></i></li>
                    <li><i class="fa fa-glide"></i></li>
                    <li><i class="fa fa-glide-g"></i></li>
                    <li><i class="fa fa-google-plus-circle"></i></li>
                    <li><i class="fa fa-google-plus-official"></i></li>
                    <li><i class="fa fa-hard-of-hearing"></i></li>
                    <li><i class="fa fa-instagram"></i></li>
                    <li><i class="fa fa-low-vision"></i></li>
                    <li><i class="fa fa-pied-piper"></i></li>
                    <li><i class="fa fa-question-circle-o"></i></li>
                    <li><i class="fa fa-sign-language"></i></li>
                    <li><i class="fa fa-signing"></i></li>
                    <li><i class="fa fa-snapchat"></i></li>
                    <li><i class="fa fa-snapchat-ghost"></i></li>
                    <li><i class="fa fa-snapchat-square"></i></li>
                    <li><i class="fa fa-themeisle"></i></li>
                    <li><i class="fa fa-universal-access"></i></li>
                    <li><i class="fa fa-viadeo"></i></li>
                    <li><i class="fa fa-viadeo-square"></i></li>
                    <li><i class="fa fa-volume-control-phone"></i></li>
                    <li><i class="fa fa-wheelchair-alt"></i></li>
                    <li><i class="fa fa-wpbeginner"></i></li>
                    <li><i class="fa fa-wpforms"></i></li>
                    <li><i class="fa fa-yoast"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Web Application Icons</strong></h3>
                    <li><i class="fa fa-adjust"></i></li>
                    <li><i class="fa fa-american-sign-language-interpreting"></i></li>
                    <li><i class="fa fa-anchor"></i></li>
                    <li><i class="fa fa-archive"></i></li>
                    <li><i class="fa fa-area-chart"></i></li>
                    <li><i class="fa fa-arrows"></i></li>
                    <li><i class="fa fa-arrows-h"></i></li>
                    <li><i class="fa fa-arrows-v"></i></li>
                    <li><i class="fa fa-asl-interpreting"></i></li>
                    <li><i class="fa fa-assistive-listening-systems"></i></li>
                    <li><i class="fa fa-asterisk"></i></li>
                    <li><i class="fa fa-at"></i></li>
                    <li><i class="fa fa-audio-description"></i></li>
                    <li><i class="fa fa-automobile"></i></li>
                    <li><i class="fa fa-balance-scale"></i></li>
                    <li><i class="fa fa-ban"></i></li>
                    <li><i class="fa fa-bank"></i></li>
                    <li><i class="fa fa-bar-chart"></i></li>
                    <li><i class="fa fa-bar-chart-o"></i></li>
                    <li><i class="fa fa-barcode"></i></li>
                    <li><i class="fa fa-bars"></i></li>
                    <li><i class="fa fa-battery-0"></i></li>
                    <li><i class="fa fa-battery-1"></i></li>
                    <li><i class="fa fa-battery-2"></i></li>
                    <li><i class="fa fa-battery-3"></i></li>
                    <li><i class="fa fa-battery-4"></i></li>
                    <li><i class="fa fa-battery-empty"></i></li>
                    <li><i class="fa fa-battery-full"></i></li>
                    <li><i class="fa fa-battery-half"></i></li>
                    <li><i class="fa fa-battery-quarter"></i></li>
                    <li><i class="fa fa-battery-three-quarters"></i></li>
                    <li><i class="fa fa-bed"></i></li>
                    <li><i class="fa fa-beer"></i></li>
                    <li><i class="fa fa-bell"></i></li>
                    <li><i class="fa fa-bell-o"></i></li>
                    <li><i class="fa fa-bell-slash"></i></li>
                    <li><i class="fa fa-bell-slash-o"></i></li>
                    <li><i class="fa fa-bicycle"></i></li>
                    <li><i class="fa fa-binoculars"></i></li>
                    <li><i class="fa fa-birthday-cake"></i></li>
                    <li><i class="fa fa-blind"></i></li>
                    <li><i class="fa fa-bluetooth"></i></li>
                    <li><i class="fa fa-bluetooth-b"></i></li>
                    <li><i class="fa fa-bolt"></i></li>
                    <li><i class="fa fa-bomb"></i></li>
                    <li><i class="fa fa-book"></i></li>
                    <li><i class="fa fa-bookmark"></i></li>
                    <li><i class="fa fa-bookmark-o"></i></li>
                    <li><i class="fa fa-braille"></i></li>
                    <li><i class="fa fa-briefcase"></i></li>
                    <li><i class="fa fa-bug"></i></li>
                    <li><i class="fa fa-building"></i></li>
                    <li><i class="fa fa-building-o"></i></li>
                    <li><i class="fa fa-bullhorn"></i></li>
                    <li><i class="fa fa-bullseye"></i></li>
                    <li><i class="fa fa-bus"></i></li>
                    <li><i class="fa fa-cab"></i></li>
                    <li><i class="fa fa-calculator"></i></li>
                    <li><i class="fa fa-calendar"></i></li>
                    <li><i class="fa fa-calendar-check-o"></i></li>
                    <li><i class="fa fa-calendar-minus-o"></i></li>
                    <li><i class="fa fa-calendar-o"></i></li>
                    <li><i class="fa fa-calendar-plus-o"></i></li>
                    <li><i class="fa fa-calendar-times-o"></i></li>
                    <li><i class="fa fa-camera"></i></li>
                    <li><i class="fa fa-camera-retro"></i></li>
                    <li><i class="fa fa-car"></i></li>
                    <li><i class="fa fa-caret-square-o-down"></i></li>
                    <li><i class="fa fa-caret-square-o-left"></i></li>
                    <li><i class="fa fa-caret-square-o-right"></i></li>
                    <li><i class="fa fa-caret-square-o-up"></i></li>
                    <li><i class="fa fa-cart-arrow-down"></i></li>
                    <li><i class="fa fa-cart-plus"></i></li>
                    <li><i class="fa fa-cc"></i></li>
                    <li><i class="fa fa-certificate"></i></li>
                    <li><i class="fa fa-check"></i></li>
                    <li><i class="fa fa-check-circle"></i></li>
                    <li><i class="fa fa-check-circle-o"></i></li>
                    <li><i class="fa fa-check-square"></i></li>
                    <li><i class="fa fa-check-square-o"></i></li>
                    <li><i class="fa fa-child"></i></li>
                    <li><i class="fa fa-circle"></i></li>
                    <li><i class="fa fa-circle-o"></i></li>
                    <li><i class="fa fa-circle-o-notch"></i></li>
                    <li><i class="fa fa-circle-thin"></i></li>
                    <li><i class="fa fa-clock-o"></i></li>
                    <li><i class="fa fa-clone"></i></li>
                    <li><i class="fa fa-close"></i></li>
                    <li><i class="fa fa-cloud"></i></li>
                    <li><i class="fa fa-cloud-download"></i></li>
                    <li><i class="fa fa-cloud-upload"></i></li>
                    <li><i class="fa fa-code"></i></li>
                    <li><i class="fa fa-code-fork"></i></li>
                    <li><i class="fa fa-coffee"></i></li>
                    <li><i class="fa fa-cog"></i></li>
                    <li><i class="fa fa-cogs"></i></li>
                    <li><i class="fa fa-comment"></i></li>
                    <li><i class="fa fa-comment-o"></i></li>
                    <li><i class="fa fa-commenting"></i></li>
                    <li><i class="fa fa-commenting-o"></i></li>
                    <li><i class="fa fa-comments"></i></li>
                    <li><i class="fa fa-comments-o"></i></li>
                    <li><i class="fa fa-compass"></i></li>
                    <li><i class="fa fa-copyright"></i></li>
                    <li><i class="fa fa-creative-commons"></i></li>
                    <li><i class="fa fa-credit-card"></i></li>
                    <li><i class="fa fa-credit-card-alt"></i></li>
                    <li><i class="fa fa-crop"></i></li>
                    <li><i class="fa fa-crosshairs"></i></li>
                    <li><i class="fa fa-cube"></i></li>
                    <li><i class="fa fa-cubes"></i></li>
                    <li><i class="fa fa-cutlery"></i></li>
                    <li><i class="fa fa-dashboard"></i></li>
                    <li><i class="fa fa-database"></i></li>
                    <li><i class="fa fa-deaf"></i></li>
                    <li><i class="fa fa-deafness"></i></li>
                    <li><i class="fa fa-desktop"></i></li>
                    <li><i class="fa fa-diamond"></i></li>
                    <li><i class="fa fa-dot-circle-o"></i></li>
                    <li><i class="fa fa-download"></i></li>
                    <li><i class="fa fa-edit"></i></li>
                    <li><i class="fa fa-ellipsis-h"></i></li>
                    <li><i class="fa fa-ellipsis-v"></i></li>
                    <li><i class="fa fa-envelope"></i></li>
                    <li><i class="fa fa-envelope-o"></i></li>
                    <li><i class="fa fa-envelope-square"></i></li>
                    <li><i class="fa fa-eraser"></i></li>
                    <li><i class="fa fa-exchange"></i></li>
                    <li><i class="fa fa-exclamation"></i></li>
                    <li><i class="fa fa-exclamation-circle"></i></li>
                    <li><i class="fa fa-exclamation-triangle"></i></li>
                    <li><i class="fa fa-external-link"></i></li>
                    <li><i class="fa fa-external-link-square"></i></li>
                    <li><i class="fa fa-eye"></i></li>
                    <li><i class="fa fa-eye-slash"></i></li>
                    <li><i class="fa fa-eyedropper"></i></li>
                    <li><i class="fa fa-fax"></i></li>
                    <li><i class="fa fa-feed"></i></li>
                    <li><i class="fa fa-female"></i></li>
                    <li><i class="fa fa-fighter-jet"></i></li>
                    <li><i class="fa fa-file-archive-o"></i></li>
                    <li><i class="fa fa-file-audio-o"></i></li>
                    <li><i class="fa fa-file-code-o"></i></li>
                    <li><i class="fa fa-file-excel-o"></i></li>
                    <li><i class="fa fa-file-image-o"></i></li>
                    <li><i class="fa fa-file-movie-o"></i></li>
                    <li><i class="fa fa-file-pdf-o"></i></li>
                    <li><i class="fa fa-file-photo-o"></i></li>
                    <li><i class="fa fa-file-picture-o"></i></li>
                    <li><i class="fa fa-file-powerpoint-o"></i></li>
                    <li><i class="fa fa-file-sound-o"></i></li>
                    <li><i class="fa fa-file-video-o"></i></li>
                    <li><i class="fa fa-file-word-o"></i></li>
                    <li><i class="fa fa-file-zip-o"></i></li>
                    <li><i class="fa fa-film"></i></li>
                    <li><i class="fa fa-filter"></i></li>
                    <li><i class="fa fa-fire"></i></li>
                    <li><i class="fa fa-fire-extinguisher"></i></li>
                    <li><i class="fa fa-flag"></i></li>
                    <li><i class="fa fa-flag-checkered"></i></li>
                    <li><i class="fa fa-flag-o"></i></li>
                    <li><i class="fa fa-flash"></i></li>
                    <li><i class="fa fa-flask"></i></li>
                    <li><i class="fa fa-folder"></i></li>
                    <li><i class="fa fa-folder-o"></i></li>
                    <li><i class="fa fa-folder-open"></i></li>
                    <li><i class="fa fa-folder-open-o"></i></li>
                    <li><i class="fa fa-frown-o"></i></li>
                    <li><i class="fa fa-futbol-o"></i></li>
                    <li><i class="fa fa-gamepad"></i></li>
                    <li><i class="fa fa-gavel"></i></li>
                    <li><i class="fa fa-gear"></i></li>
                    <li><i class="fa fa-gears"></i></li>
                    <li><i class="fa fa-gift"></i></li>
                    <li><i class="fa fa-glass"></i></li>
                    <li><i class="fa fa-globe"></i></li>
                    <li><i class="fa fa-graduation-cap"></i></li>
                    <li><i class="fa fa-group"></i></li>
                    <li><i class="fa fa-hand-grab-o"></i></li>
                    <li><i class="fa fa-hand-lizard-o"></i></li>
                    <li><i class="fa fa-hand-paper-o"></i></li>
                    <li><i class="fa fa-hand-peace-o"></i></li>
                    <li><i class="fa fa-hand-pointer-o"></i></li>
                    <li><i class="fa fa-hand-rock-o"></i></li>
                    <li><i class="fa fa-hand-scissors-o"></i></li>
                    <li><i class="fa fa-hand-spock-o"></i></li>
                    <li><i class="fa fa-hand-stop-o"></i></li>
                    <li><i class="fa fa-hard-of-hearing"></i></li>
                    <li><i class="fa fa-hashtag"></i></li>
                    <li><i class="fa fa-hdd-o"></i></li>
                    <li><i class="fa fa-headphones"></i></li>
                    <li><i class="fa fa-heart"></i></li>
                    <li><i class="fa fa-heart-o"></i></li>
                    <li><i class="fa fa-heartbeat"></i></li>
                    <li><i class="fa fa-history"></i></li>
                    <li><i class="fa fa-home"></i></li>
                    <li><i class="fa fa-hotel"></i></li>
                    <li><i class="fa fa-hourglass"></i></li>
                    <li><i class="fa fa-hourglass-1"></i></li>
                    <li><i class="fa fa-hourglass-2"></i></li>
                    <li><i class="fa fa-hourglass-3"></i></li>
                    <li><i class="fa fa-hourglass-end"></i></li>
                    <li><i class="fa fa-hourglass-half"></i></li>
                    <li><i class="fa fa-hourglass-o"></i></li>
                    <li><i class="fa fa-hourglass-start"></i></li>
                    <li><i class="fa fa-i-cursor"></i></li>
                    <li><i class="fa fa-image"></i></li>
                    <li><i class="fa fa-inbox"></i></li>
                    <li><i class="fa fa-industry"></i></li>
                    <li><i class="fa fa-info"></i></li>
                    <li><i class="fa fa-info-circle"></i></li>
                    <li><i class="fa fa-institution"></i></li>
                    <li><i class="fa fa-key"></i></li>
                    <li><i class="fa fa-keyboard-o"></i></li>
                    <li><i class="fa fa-language"></i></li>
                    <li><i class="fa fa-laptop"></i></li>
                    <li><i class="fa fa-leaf"></i></li>
                    <li><i class="fa fa-legal"></i></li>
                    <li><i class="fa fa-lemon-o"></i></li>
                    <li><i class="fa fa-level-down"></i></li>
                    <li><i class="fa fa-level-up"></i></li>
                    <li><i class="fa fa-life-bouy"></i></li>
                    <li><i class="fa fa-life-buoy"></i></li>
                    <li><i class="fa fa-life-ring"></i></li>
                    <li><i class="fa fa-life-saver"></i></li>
                    <li><i class="fa fa-lightbulb-o"></i></li>
                    <li><i class="fa fa-line-chart"></i></li>
                    <li><i class="fa fa-location-arrow"></i></li>
                    <li><i class="fa fa-lock"></i></li>
                    <li><i class="fa fa-low-vision"></i></li>
                    <li><i class="fa fa-magic"></i></li>
                    <li><i class="fa fa-magnet"></i></li>
                    <li><i class="fa fa-mail-forward"></i></li>
                    <li><i class="fa fa-mail-reply"></i></li>
                    <li><i class="fa fa-mail-reply-all"></i></li>
                    <li><i class="fa fa-male"></i></li>
                    <li><i class="fa fa-map"></i></li>
                    <li><i class="fa fa-map-marker"></i></li>
                    <li><i class="fa fa-map-o"></i></li>
                    <li><i class="fa fa-map-pin"></i></li>
                    <li><i class="fa fa-map-signs"></i></li>
                    <li><i class="fa fa-meh-o"></i></li>
                    <li><i class="fa fa-microphone"></i></li>
                    <li><i class="fa fa-microphone-slash"></i></li>
                    <li><i class="fa fa-minus"></i></li>
                    <li><i class="fa fa-minus-circle"></i></li>
                    <li><i class="fa fa-minus-square"></i></li>
                    <li><i class="fa fa-minus-square-o"></i></li>
                    <li><i class="fa fa-mobile"></i></li>
                    <li><i class="fa fa-mobile-phone"></i></li>
                    <li><i class="fa fa-money"></i></li>
                    <li><i class="fa fa-moon-o"></i></li>
                    <li><i class="fa fa-mortar-board"></i></li>
                    <li><i class="fa fa-motorcycle"></i></li>
                    <li><i class="fa fa-mouse-pointer"></i></li>
                    <li><i class="fa fa-music"></i></li>
                    <li><i class="fa fa-navicon"></i></li>
                    <li><i class="fa fa-newspaper-o"></i></li>
                    <li><i class="fa fa-object-group"></i></li>
                    <li><i class="fa fa-object-ungroup"></i></li>
                    <li><i class="fa fa-paint-brush"></i></li>
                    <li><i class="fa fa-paper-plane"></i></li>
                    <li><i class="fa fa-paper-plane-o"></i></li>
                    <li><i class="fa fa-paw"></i></li>
                    <li><i class="fa fa-pencil"></i></li>
                    <li><i class="fa fa-pencil-square"></i></li>
                    <li><i class="fa fa-pencil-square-o"></i></li>
                    <li><i class="fa fa-percent"></i></li>
                    <li><i class="fa fa-phone"></i></li>
                    <li><i class="fa fa-phone-square"></i></li>
                    <li><i class="fa fa-photo"></i></li>
                    <li><i class="fa fa-picture-o"></i></li>
                    <li><i class="fa fa-pie-chart"></i></li>
                    <li><i class="fa fa-plane"></i></li>
                    <li><i class="fa fa-plug"></i></li>
                    <li><i class="fa fa-plus"></i></li>
                    <li><i class="fa fa-plus-circle"></i></li>
                    <li><i class="fa fa-plus-square"></i></li>
                    <li><i class="fa fa-plus-square-o"></i></li>
                    <li><i class="fa fa-power-off"></i></li>
                    <li><i class="fa fa-print"></i></li>
                    <li><i class="fa fa-puzzle-piece"></i></li>
                    <li><i class="fa fa-qrcode"></i></li>
                    <li><i class="fa fa-question"></i></li>
                    <li><i class="fa fa-question-circle"></i></li>
                    <li><i class="fa fa-question-circle-o"></i></li>
                    <li><i class="fa fa-quote-left"></i></li>
                    <li><i class="fa fa-quote-right"></i></li>
                    <li><i class="fa fa-random"></i></li>
                    <li><i class="fa fa-recycle"></i></li>
                    <li><i class="fa fa-refresh"></i></li>
                    <li><i class="fa fa-registered"></i></li>
                    <li><i class="fa fa-remove"></i></li>
                    <li><i class="fa fa-reorder"></i></li>
                    <li><i class="fa fa-reply"></i></li>
                    <li><i class="fa fa-reply-all"></i></li>
                    <li><i class="fa fa-retweet"></i></li>
                    <li><i class="fa fa-road"></i></li>
                    <li><i class="fa fa-rocket"></i></li>
                    <li><i class="fa fa-rss"></i></li>
                    <li><i class="fa fa-rss-square"></i></li>
                    <li><i class="fa fa-search"></i></li>
                    <li><i class="fa fa-search-minus"></i></li>
                    <li><i class="fa fa-search-plus"></i></li>
                    <li><i class="fa fa-send"></i></li>
                    <li><i class="fa fa-send-o"></i></li>
                    <li><i class="fa fa-server"></i></li>
                    <li><i class="fa fa-share"></i></li>
                    <li><i class="fa fa-share-alt"></i></li>
                    <li><i class="fa fa-share-alt-square"></i></li>
                    <li><i class="fa fa-share-square"></i></li>
                    <li><i class="fa fa-share-square-o"></i></li>
                    <li><i class="fa fa-shield"></i></li>
                    <li><i class="fa fa-ship"></i></li>
                    <li><i class="fa fa-shopping-bag"></i></li>
                    <li><i class="fa fa-shopping-basket"></i></li>
                    <li><i class="fa fa-shopping-cart"></i></li>
                    <li><i class="fa fa-sign-in"></i></li>
                    <li><i class="fa fa-sign-language"></i></li>
                    <li><i class="fa fa-sign-out"></i></li>
                    <li><i class="fa fa-signal"></i></li>
                    <li><i class="fa fa-signing"></i></li>
                    <li><i class="fa fa-sitemap"></i></li>
                    <li><i class="fa fa-sliders"></i></li>
                    <li><i class="fa fa-smile-o"></i></li>
                    <li><i class="fa fa-soccer-ball-o"></i></li>
                    <li><i class="fa fa-sort"></i></li>
                    <li><i class="fa fa-sort-alpha-asc"></i></li>
                    <li><i class="fa fa-sort-alpha-desc"></i></li>
                    <li><i class="fa fa-sort-amount-asc"></i></li>
                    <li><i class="fa fa-sort-amount-desc"></i></li>
                    <li><i class="fa fa-sort-asc"></i></li>
                    <li><i class="fa fa-sort-desc"></i></li>
                    <li><i class="fa fa-sort-down"></i></li>
                    <li><i class="fa fa-sort-numeric-asc"></i></li>
                    <li><i class="fa fa-sort-numeric-desc"></i></li>
                    <li><i class="fa fa-sort-up"></i></li>
                    <li><i class="fa fa-space-shuttle"></i></li>
                    <li><i class="fa fa-spinner"></i></li>
                    <li><i class="fa fa-spoon"></i></li>
                    <li><i class="fa fa-square"></i></li>
                    <li><i class="fa fa-square-o"></i></li>
                    <li><i class="fa fa-star"></i></li>
                    <li><i class="fa fa-star-half"></i></li>
                    <li><i class="fa fa-star-half-empty"></i></li>
                    <li><i class="fa fa-star-half-full"></i></li>
                    <li><i class="fa fa-star-half-o"></i></li>
                    <li><i class="fa fa-star-o"></i></li>
                    <li><i class="fa fa-sticky-note"></i></li>
                    <li><i class="fa fa-sticky-note-o"></i></li>
                    <li><i class="fa fa-street-view"></i></li>
                    <li><i class="fa fa-suitcase"></i></li>
                    <li><i class="fa fa-sun-o"></i></li>
                    <li><i class="fa fa-support"></i></li>
                    <li><i class="fa fa-tablet"></i></li>
                    <li><i class="fa fa-tachometer"></i></li>
                    <li><i class="fa fa-tag"></i></li>
                    <li><i class="fa fa-tags"></i></li>
                    <li><i class="fa fa-tasks"></i></li>
                    <li><i class="fa fa-taxi"></i></li>
                    <li><i class="fa fa-television"></i></li>
                    <li><i class="fa fa-terminal"></i></li>
                    <li><i class="fa fa-thumb-tack"></i></li>
                    <li><i class="fa fa-thumbs-down"></i></li>
                    <li><i class="fa fa-thumbs-o-down"></i></li>
                    <li><i class="fa fa-thumbs-o-up"></i></li>
                    <li><i class="fa fa-thumbs-up"></i></li>
                    <li><i class="fa fa-ticket"></i></li>
                    <li><i class="fa fa-times"></i></li>
                    <li><i class="fa fa-times-circle"></i></li>
                    <li><i class="fa fa-times-circle-o"></i></li>
                    <li><i class="fa fa-tint"></i></li>
                    <li><i class="fa fa-toggle-down"></i></li>
                    <li><i class="fa fa-toggle-left"></i></li>
                    <li><i class="fa fa-toggle-off"></i></li>
                    <li><i class="fa fa-toggle-on"></i></li>
                    <li><i class="fa fa-toggle-right"></i></li>
                    <li><i class="fa fa-toggle-up"></i></li>
                    <li><i class="fa fa-trademark"></i></li>
                    <li><i class="fa fa-trash"></i></li>
                    <li><i class="fa fa-trash-o"></i></li>
                    <li><i class="fa fa-tree"></i></li>
                    <li><i class="fa fa-trophy"></i></li>
                    <li><i class="fa fa-truck"></i></li>
                    <li><i class="fa fa-tty"></i></li>
                    <li><i class="fa fa-tv"></i></li>
                    <li><i class="fa fa-umbrella"></i></li>
                    <li><i class="fa fa-universal-access"></i></li>
                    <li><i class="fa fa-university"></i></li>
                    <li><i class="fa fa-unlock"></i></li>
                    <li><i class="fa fa-unlock-alt"></i></li>
                    <li><i class="fa fa-unsorted"></i></li>
                    <li><i class="fa fa-upload"></i></li>
                    <li><i class="fa fa-user"></i></li>
                    <li><i class="fa fa-user-plus"></i></li>
                    <li><i class="fa fa-user-secret"></i></li>
                    <li><i class="fa fa-user-times"></i></li>
                    <li><i class="fa fa-users"></i></li>
                    <li><i class="fa fa-video-camera"></i></li>
                    <li><i class="fa fa-volume-control-phone"></i></li>
                    <li><i class="fa fa-volume-down"></i></li>
                    <li><i class="fa fa-volume-off"></i></li>
                    <li><i class="fa fa-volume-up"></i></li>
                    <li><i class="fa fa-warning"></i></li>
                    <li><i class="fa fa-wheelchair"></i></li>
                    <li><i class="fa fa-wheelchair-alt"></i></li>
                    <li><i class="fa fa-wifi"></i></li>
                    <li><i class="fa fa-wrench"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Accessibility Icons</strong></h3>
                    <li><i class="fa fa-american-sign-language-interpreting"></i></li>
                    <li><i class="fa fa-asl-interpreting"></i></li>
                    <li><i class="fa fa-assistive-listening-systems"></i></li>
                    <li><i class="fa fa-audio-description"></i></li>
                    <li><i class="fa fa-blind"></i></li>
                    <li><i class="fa fa-braille"></i></li>
                    <li><i class="fa fa-cc"></i></li>
                    <li><i class="fa fa-deaf"></i></li>
                    <li><i class="fa fa-deafness"></i></li>
                    <li><i class="fa fa-hard-of-hearing"></i></li>
                    <li><i class="fa fa-low-vision"></i></li>
                    <li><i class="fa fa-question-circle-o"></i></li>
                    <li><i class="fa fa-sign-language"></i></li>
                    <li><i class="fa fa-signing"></i></li>
                    <li><i class="fa fa-tty"></i></li>
                    <li><i class="fa fa-universal-access"></i></li>
                    <li><i class="fa fa-volume-control-phone"></i></li>
                    <li><i class="fa fa-wheelchair"></i></li>
                    <li><i class="fa fa-wheelchair-alt"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Hand Icons</strong></h3>
                    <li><i class="fa fa-hand-grab-o"></i></li>
                    <li><i class="fa fa-hand-lizard-o"></i></li>
                    <li><i class="fa fa-hand-o-down"></i></li>
                    <li><i class="fa fa-hand-o-left"></i></li>
                    <li><i class="fa fa-hand-o-right"></i></li>
                    <li><i class="fa fa-hand-o-up"></i></li>
                    <li><i class="fa fa-hand-paper-o"></i></li>
                    <li><i class="fa fa-hand-peace-o"></i></li>
                    <li><i class="fa fa-hand-pointer-o"></i></li>
                    <li><i class="fa fa-hand-rock-o"></i></li>
                    <li><i class="fa fa-hand-scissors-o"></i></li>
                    <li><i class="fa fa-hand-spock-o"></i></li>
                    <li><i class="fa fa-hand-stop-o"></i></li>
                    <li><i class="fa fa-thumbs-down"></i></li>
                    <li><i class="fa fa-thumbs-o-down"></i></li>
                    <li><i class="fa fa-thumbs-o-up"></i></li>
                    <li><i class="fa fa-thumbs-up"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Transportation Icons</strong></h3>
                    <li><i class="fa fa-ambulance"></i></li>
                    <li><i class="fa fa-automobile"></i></li>
                    <li><i class="fa fa-bicycle"></i></li>
                    <li><i class="fa fa-bus"></i></li>
                    <li><i class="fa fa-cab"></i></li>
                    <li><i class="fa fa-car"></i></li>
                    <li><i class="fa fa-fighter-jet"></i></li>
                    <li><i class="fa fa-motorcycle"></i></li>
                    <li><i class="fa fa-plane"></i></li>
                    <li><i class="fa fa-rocket"></i></li>
                    <li><i class="fa fa-ship"></i></li>
                    <li><i class="fa fa-space-shuttle"></i></li>
                    <li><i class="fa fa-subway"></i></li>
                    <li><i class="fa fa-taxi"></i></li>
                    <li><i class="fa fa-train"></i></li>
                    <li><i class="fa fa-truck"></i></li>
                    <li><i class="fa fa-wheelchair"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Gender Icons</strong></h3>
                    <li><i class="fa fa-genderless"></i></li>
                    <li><i class="fa fa-intersex"></i></li>
                    <li><i class="fa fa-mars"></i></li>
                    <li><i class="fa fa-mars-double"></i></li>
                    <li><i class="fa fa-mars-stroke"></i></li>
                    <li><i class="fa fa-mars-stroke-h"></i></li>
                    <li><i class="fa fa-mars-stroke-v"></i></li>
                    <li><i class="fa fa-mercury"></i></li>
                    <li><i class="fa fa-neuter"></i></li>
                    <li><i class="fa fa-transgender"></i></li>
                    <li><i class="fa fa-transgender-alt"></i></li>
                    <li><i class="fa fa-venus"></i></li>
                    <li><i class="fa fa-venus-double"></i></li>
                    <li><i class="fa fa-venus-mars"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>File Type Icons</strong></h3>
                    <li><i class="fa fa-file"></i></li>
                    <li><i class="fa fa-file-archive-o"></i></li>
                    <li><i class="fa fa-file-audio-o"></i></li>
                    <li><i class="fa fa-file-code-o"></i></li>
                    <li><i class="fa fa-file-excel-o"></i></li>
                    <li><i class="fa fa-file-image-o"></i></li>
                    <li><i class="fa fa-file-movie-o"></i></li>
                    <li><i class="fa fa-file-o"></i></li>
                    <li><i class="fa fa-file-pdf-o"></i></li>
                    <li><i class="fa fa-file-photo-o"></i></li>
                    <li><i class="fa fa-file-picture-o"></i></li>
                    <li><i class="fa fa-file-powerpoint-o"></i></li>
                    <li><i class="fa fa-file-sound-o"></i></li>
                    <li><i class="fa fa-file-text"></i></li>
                    <li><i class="fa fa-file-text-o"></i></li>
                    <li><i class="fa fa-file-video-o"></i></li>
                    <li><i class="fa fa-file-word-o"></i></li>
                    <li><i class="fa fa-file-zip-o"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Spinner Icons</strong></h3>
                    <li><i class="fa fa-circle-o-notch"></i></li>
                    <li><i class="fa fa-cog"></i></li>
                    <li><i class="fa fa-gear"></i></li>
                    <li><i class="fa fa-refresh"></i></li>
                    <li><i class="fa fa-spinner"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Form Control Icons</strong></h3>
                    <li><i class="fa fa-check-square"></i></li>
                    <li><i class="fa fa-check-square-o"></i></li>
                    <li><i class="fa fa-circle"></i></li>
                    <li><i class="fa fa-circle-o"></i></li>
                    <li><i class="fa fa-dot-circle-o"></i></li>
                    <li><i class="fa fa-minus-square"></i></li>
                    <li><i class="fa fa-minus-square-o"></i></li>
                    <li><i class="fa fa-plus-square"></i></li>
                    <li><i class="fa fa-plus-square-o"></i></li>
                    <li><i class="fa fa-square"></i></li>
                    <li><i class="fa fa-square-o"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Payment Icons</strong></h3>
                    <li><i class="fa fa-cc-amex"></i></li>
                    <li><i class="fa fa-cc-diners-club"></i></li>
                    <li><i class="fa fa-cc-discover"></i></li>
                    <li><i class="fa fa-cc-jcb"></i></li>
                    <li><i class="fa fa-cc-mastercard"></i></li>
                    <li><i class="fa fa-cc-paypal"></i></li>
                    <li><i class="fa fa-cc-stripe"></i></li>
                    <li><i class="fa fa-cc-visa"></i></li>
                    <li><i class="fa fa-credit-card"></i></li>
                    <li><i class="fa fa-credit-card-alt"></i></li>
                    <li><i class="fa fa-google-wallet"></i></li>
                    <li><i class="fa fa-paypal"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Chart Icons</strong></h3>
                    <li><i class="fa fa-area-chart"></i></li>
                    <li><i class="fa fa-bar-chart"></i></li>
                    <li><i class="fa fa-bar-chart-o"></i></li>
                    <li><i class="fa fa-line-chart"></i></li>
                    <li><i class="fa fa-pie-chart"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Currency Icons</strong></h3>
                    <li><i class="fa fa-bitcoin"></i></li>
                    <li><i class="fa fa-btc"></i></li>
                    <li><i class="fa fa-cny"></i></li>
                    <li><i class="fa fa-dollar"></i></li>
                    <li><i class="fa fa-eur"></i></li>
                    <li><i class="fa fa-euro"></i></li>
                    <li><i class="fa fa-gbp"></i></li>
                    <li><i class="fa fa-gg"></i></li>
                    <li><i class="fa fa-gg-circle"></i></li>
                    <li><i class="fa fa-ils"></i></li>
                    <li><i class="fa fa-inr"></i></li>
                    <li><i class="fa fa-jpy"></i></li>
                    <li><i class="fa fa-krw"></i></li>
                    <li><i class="fa fa-money"></i></li>
                    <li><i class="fa fa-rmb"></i></li>
                    <li><i class="fa fa-rouble"></i></li>
                    <li><i class="fa fa-rub"></i></li>
                    <li><i class="fa fa-ruble"></i></li>
                    <li><i class="fa fa-rupee"></i></li>
                    <li><i class="fa fa-shekel"></i></li>
                    <li><i class="fa fa-sheqel"></i></li>
                    <li><i class="fa fa-try"></i></li>
                    <li><i class="fa fa-turkish-lira"></i></li>
                    <li><i class="fa fa-usd"></i></li>
                    <li><i class="fa fa-won"></i></li>
                    <li><i class="fa fa-yen"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Text Editor Icons</strong></h3>
                    <li><i class="fa fa-align-center"></i></li>
                    <li><i class="fa fa-align-justify"></i></li>
                    <li><i class="fa fa-align-left"></i></li>
                    <li><i class="fa fa-align-right"></i></li>
                    <li><i class="fa fa-bold"></i></li>
                    <li><i class="fa fa-chain"></i></li>
                    <li><i class="fa fa-chain-broken"></i></li>
                    <li><i class="fa fa-clipboard"></i></li>
                    <li><i class="fa fa-columns"></i></li>
                    <li><i class="fa fa-copy"></i></li>
                    <li><i class="fa fa-cut"></i></li>
                    <li><i class="fa fa-dedent"></i></li>
                    <li><i class="fa fa-eraser"></i></li>
                    <li><i class="fa fa-file"></i></li>
                    <li><i class="fa fa-file-o"></i></li>
                    <li><i class="fa fa-file-text"></i></li>
                    <li><i class="fa fa-file-text-o"></i></li>
                    <li><i class="fa fa-files-o"></i></li>
                    <li><i class="fa fa-floppy-o"></i></li>
                    <li><i class="fa fa-font"></i></li>
                    <li><i class="fa fa-header"></i></li>
                    <li><i class="fa fa-indent"></i></li>
                    <li><i class="fa fa-italic"></i></li>
                    <li><i class="fa fa-link"></i></li>
                    <li><i class="fa fa-list"></i></li>
                    <li><i class="fa fa-list-alt"></i></li>
                    <li><i class="fa fa-list-ol"></i></li>
                    <li><i class="fa fa-list-ul"></i></li>
                    <li><i class="fa fa-outdent"></i></li>
                    <li><i class="fa fa-paperclip"></i></li>
                    <li><i class="fa fa-paragraph"></i></li>
                    <li><i class="fa fa-paste"></i></li>
                    <li><i class="fa fa-repeat"></i></li>
                    <li><i class="fa fa-rotate-left"></i></li>
                    <li><i class="fa fa-rotate-right"></i></li>
                    <li><i class="fa fa-save"></i></li>
                    <li><i class="fa fa-scissors"></i></li>
                    <li><i class="fa fa-strikethrough"></i></li>
                    <li><i class="fa fa-subscript"></i></li>
                    <li><i class="fa fa-superscript"></i></li>
                    <li><i class="fa fa-table"></i></li>
                    <li><i class="fa fa-text-height"></i></li>
                    <li><i class="fa fa-text-width"></i></li>
                    <li><i class="fa fa-th"></i></li>
                    <li><i class="fa fa-th-large"></i></li>
                    <li><i class="fa fa-th-list"></i></li>
                    <li><i class="fa fa-underline"></i></li>
                    <li><i class="fa fa-undo"></i></li>
                    <li><i class="fa fa-unlink"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Directional Icons</strong></h3>
                    <li><i class="fa fa-angle-double-down"></i></li>
                    <li><i class="fa fa-angle-double-left"></i></li>
                    <li><i class="fa fa-angle-double-right"></i></li>
                    <li><i class="fa fa-angle-double-up"></i></li>
                    <li><i class="fa fa-angle-down"></i></li>
                    <li><i class="fa fa-angle-left"></i></li>
                    <li><i class="fa fa-angle-right"></i></li>
                    <li><i class="fa fa-angle-up"></i></li>
                    <li><i class="fa fa-arrow-circle-down"></i></li>
                    <li><i class="fa fa-arrow-circle-left"></i></li>
                    <li><i class="fa fa-arrow-circle-o-down"></i></li>
                    <li><i class="fa fa-arrow-circle-o-left"></i></li>
                    <li><i class="fa fa-arrow-circle-o-right"></i></li>
                    <li><i class="fa fa-arrow-circle-o-up"></i></li>
                    <li><i class="fa fa-arrow-circle-right"></i></li>
                    <li><i class="fa fa-arrow-circle-up"></i></li>
                    <li><i class="fa fa-arrow-down"></i></li>
                    <li><i class="fa fa-arrow-left"></i></li>
                    <li><i class="fa fa-arrow-right"></i></li>
                    <li><i class="fa fa-arrow-up"></i></li>
                    <li><i class="fa fa-arrows"></i></li>
                    <li><i class="fa fa-arrows-alt"></i></li>
                    <li><i class="fa fa-arrows-h"></i></li>
                    <li><i class="fa fa-arrows-v"></i></li>
                    <li><i class="fa fa-caret-down"></i></li>
                    <li><i class="fa fa-caret-left"></i></li>
                    <li><i class="fa fa-caret-right"></i></li>
                    <li><i class="fa fa-caret-square-o-down"></i></li>
                    <li><i class="fa fa-caret-square-o-left"></i></li>
                    <li><i class="fa fa-caret-square-o-right"></i></li>
                    <li><i class="fa fa-caret-square-o-up"></i></li>
                    <li><i class="fa fa-caret-up"></i></li>
                    <li><i class="fa fa-chevron-circle-down"></i></li>
                    <li><i class="fa fa-chevron-circle-left"></i></li>
                    <li><i class="fa fa-chevron-circle-right"></i></li>
                    <li><i class="fa fa-chevron-circle-up"></i></li>
                    <li><i class="fa fa-chevron-down"></i></li>
                    <li><i class="fa fa-chevron-left"></i></li>
                    <li><i class="fa fa-chevron-right"></i></li>
                    <li><i class="fa fa-chevron-up"></i></li>
                    <li><i class="fa fa-exchange"></i></li>
                    <li><i class="fa fa-hand-o-down"></i></li>
                    <li><i class="fa fa-hand-o-left"></i></li>
                    <li><i class="fa fa-hand-o-right"></i></li>
                    <li><i class="fa fa-hand-o-up"></i></li>
                    <li><i class="fa fa-long-arrow-down"></i></li>
                    <li><i class="fa fa-long-arrow-left"></i></li>
                    <li><i class="fa fa-long-arrow-right"></i></li>
                    <li><i class="fa fa-long-arrow-up"></i></li>
                    <li><i class="fa fa-toggle-down"></i></li>
                    <li><i class="fa fa-toggle-left"></i></li>
                    <li><i class="fa fa-toggle-right"></i></li>
                    <li><i class="fa fa-toggle-up"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Video Player Icons</strong></h3>
                    <li><i class="fa fa-arrows-alt"></i></li>
                    <li><i class="fa fa-backward"></i></li>
                    <li><i class="fa fa-compress"></i></li>
                    <li><i class="fa fa-eject"></i></li>
                    <li><i class="fa fa-expand"></i></li>
                    <li><i class="fa fa-fast-backward"></i></li>
                    <li><i class="fa fa-fast-forward"></i></li>
                    <li><i class="fa fa-forward"></i></li>
                    <li><i class="fa fa-pause"></i></li>
                    <li><i class="fa fa-pause-circle"></i></li>
                    <li><i class="fa fa-pause-circle-o"></i></li>
                    <li><i class="fa fa-play"></i></li>
                    <li><i class="fa fa-play-circle"></i></li>
                    <li><i class="fa fa-play-circle-o"></i></li>
                    <li><i class="fa fa-random"></i></li>
                    <li><i class="fa fa-step-backward"></i></li>
                    <li><i class="fa fa-step-forward"></i></li>
                    <li><i class="fa fa-stop"></i></li>
                    <li><i class="fa fa-stop-circle"></i></li>
                    <li><i class="fa fa-stop-circle-o"></i></li>
                    <li><i class="fa fa-youtube-play"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Brand Icons</strong></h3>
                    <li><i class="fa fa-500px"></i></li>
                    <li><i class="fa fa-adn"></i></li>
                    <li><i class="fa fa-amazon"></i></li>
                    <li><i class="fa fa-android"></i></li>
                    <li><i class="fa fa-angellist"></i></li>
                    <li><i class="fa fa-apple"></i></li>
                    <li><i class="fa fa-behance"></i></li>
                    <li><i class="fa fa-behance-square"></i></li>
                    <li><i class="fa fa-bitbucket"></i></li>
                    <li><i class="fa fa-bitbucket-square"></i></li>
                    <li><i class="fa fa-bitcoin"></i></li>
                    <li><i class="fa fa-black-tie"></i></li>
                    <li><i class="fa fa-bluetooth"></i></li>
                    <li><i class="fa fa-bluetooth-b"></i></li>
                    <li><i class="fa fa-btc"></i></li>
                    <li><i class="fa fa-buysellads"></i></li>
                    <li><i class="fa fa-cc-amex"></i></li>
                    <li><i class="fa fa-cc-diners-club"></i></li>
                    <li><i class="fa fa-cc-discover"></i></li>
                    <li><i class="fa fa-cc-jcb"></i></li>
                    <li><i class="fa fa-cc-mastercard"></i></li>
                    <li><i class="fa fa-cc-paypal"></i></li>
                    <li><i class="fa fa-cc-stripe"></i></li>
                    <li><i class="fa fa-cc-visa"></i></li>
                    <li><i class="fa fa-chrome"></i></li>
                    <li><i class="fa fa-codepen"></i></li>
                    <li><i class="fa fa-codiepie"></i></li>
                    <li><i class="fa fa-connectdevelop"></i></li>
                    <li><i class="fa fa-contao"></i></li>
                    <li><i class="fa fa-css3"></i></li>
                    <li><i class="fa fa-dashcube"></i></li>
                    <li><i class="fa fa-delicious"></i></li>
                    <li><i class="fa fa-deviantart"></i></li>
                    <li><i class="fa fa-digg"></i></li>
                    <li><i class="fa fa-dribbble"></i></li>
                    <li><i class="fa fa-dropbox"></i></li>
                    <li><i class="fa fa-drupal"></i></li>
                    <li><i class="fa fa-edge"></i></li>
                    <li><i class="fa fa-empire"></i></li>
                    <li><i class="fa fa-envira"></i></li>
                    <li><i class="fa fa-expeditedssl"></i></li>
                    <li><i class="fa fa-fa"></i></li>
                    <li><i class="fa fa-facebook"></i></li>
                    <li><i class="fa fa-facebook-f"></i></li>
                    <li><i class="fa fa-facebook-official"></i></li>
                    <li><i class="fa fa-facebook-square"></i></li>
                    <li><i class="fa fa-firefox"></i></li>
                    <li><i class="fa fa-first-order"></i></li>
                    <li><i class="fa fa-flickr"></i></li>
                    <li><i class="fa fa-font-awesome"></i></li>
                    <li><i class="fa fa-fonticons"></i></li>
                    <li><i class="fa fa-fort-awesome"></i></li>
                    <li><i class="fa fa-forumbee"></i></li>
                    <li><i class="fa fa-foursquare"></i></li>
                    <li><i class="fa fa-ge"></i></li>
                    <li><i class="fa fa-get-pocket"></i></li>
                    <li><i class="fa fa-gg"></i></li>
                    <li><i class="fa fa-gg-circle"></i></li>
                    <li><i class="fa fa-git"></i></li>
                    <li><i class="fa fa-git-square"></i></li>
                    <li><i class="fa fa-github"></i></li>
                    <li><i class="fa fa-github-alt"></i></li>
                    <li><i class="fa fa-github-square"></i></li>
                    <li><i class="fa fa-gitlab"></i></li>
                    <li><i class="fa fa-gittip"></i></li>
                    <li><i class="fa fa-glide"></i></li>
                    <li><i class="fa fa-glide-g"></i></li>
                    <li><i class="fa fa-google"></i></li>
                    <li><i class="fa fa-google-plus"></i></li>
                    <li><i class="fa fa-google-plus-circle"></i></li>
                    <li><i class="fa fa-google-plus-official"></i></li>
                    <li><i class="fa fa-google-plus-square"></i></li>
                    <li><i class="fa fa-google-wallet"></i></li>
                    <li><i class="fa fa-gratipay"></i></li>
                    <li><i class="fa fa-hacker-news"></i></li>
                    <li><i class="fa fa-houzz"></i></li>
                    <li><i class="fa fa-html5"></i></li>
                    <li><i class="fa fa-instagram"></i></li>
                    <li><i class="fa fa-internet-explorer"></i></li>
                    <li><i class="fa fa-ioxhost"></i></li>
                    <li><i class="fa fa-joomla"></i></li>
                    <li><i class="fa fa-jsfiddle"></i></li>
                    <li><i class="fa fa-lastfm"></i></li>
                    <li><i class="fa fa-lastfm-square"></i></li>
                    <li><i class="fa fa-leanpub"></i></li>
                    <li><i class="fa fa-linkedin"></i></li>
                    <li><i class="fa fa-linkedin-square"></i></li>
                    <li><i class="fa fa-linux"></i></li>
                    <li><i class="fa fa-maxcdn"></i></li>
                    <li><i class="fa fa-meanpath"></i></li>
                    <li><i class="fa fa-medium"></i></li>
                    <li><i class="fa fa-mixcloud"></i></li>
                    <li><i class="fa fa-modx"></i></li>
                    <li><i class="fa fa-odnoklassniki"></i></li>
                    <li><i class="fa fa-odnoklassniki-square"></i></li>
                    <li><i class="fa fa-opencart"></i></li>
                    <li><i class="fa fa-openid"></i></li>
                    <li><i class="fa fa-opera"></i></li>
                    <li><i class="fa fa-optin-monster"></i></li>
                    <li><i class="fa fa-pagelines"></i></li>
                    <li><i class="fa fa-paypal"></i></li>
                    <li><i class="fa fa-pied-piper"></i></li>
                    <li><i class="fa fa-pied-piper-alt"></i></li>
                    <li><i class="fa fa-pied-piper-pp"></i></li>
                    <li><i class="fa fa-pinterest"></i></li>
                    <li><i class="fa fa-pinterest-p"></i></li>
                    <li><i class="fa fa-pinterest-square"></i></li>
                    <li><i class="fa fa-product-hunt"></i></li>
                    <li><i class="fa fa-qq"></i></li>
                    <li><i class="fa fa-ra"></i></li>
                    <li><i class="fa fa-rebel"></i></li>
                    <li><i class="fa fa-reddit"></i></li>
                    <li><i class="fa fa-reddit-alien"></i></li>
                    <li><i class="fa fa-reddit-square"></i></li>
                    <li><i class="fa fa-renren"></i></li>
                    <li><i class="fa fa-resistance"></i></li>
                    <li><i class="fa fa-safari"></i></li>
                    <li><i class="fa fa-scribd"></i></li>
                    <li><i class="fa fa-sellsy"></i></li>
                    <li><i class="fa fa-share-alt"></i></li>
                    <li><i class="fa fa-share-alt-square"></i></li>
                    <li><i class="fa fa-shirtsinbulk"></i></li>
                    <li><i class="fa fa-simplybuilt"></i></li>
                    <li><i class="fa fa-skyatlas"></i></li>
                    <li><i class="fa fa-skype"></i></li>
                    <li><i class="fa fa-slack"></i></li>
                    <li><i class="fa fa-slideshare"></i></li>
                    <li><i class="fa fa-snapchat"></i></li>
                    <li><i class="fa fa-snapchat-ghost"></i></li>
                    <li><i class="fa fa-snapchat-square"></i></li>
                    <li><i class="fa fa-soundcloud"></i></li>
                    <li><i class="fa fa-spotify"></i></li>
                    <li><i class="fa fa-stack-exchange"></i></li>
                    <li><i class="fa fa-stack-overflow"></i></li>
                    <li><i class="fa fa-steam"></i></li>
                    <li><i class="fa fa-steam-square"></i></li>
                    <li><i class="fa fa-stumbleupon"></i></li>
                    <li><i class="fa fa-stumbleupon-circle"></i></li>
                    <li><i class="fa fa-tencent-weibo"></i></li>
                    <li><i class="fa fa-themeisle"></i></li>
                    <li><i class="fa fa-trello"></i></li>
                    <li><i class="fa fa-tripadvisor"></i></li>
                    <li><i class="fa fa-tumblr"></i></li>
                    <li><i class="fa fa-tumblr-square"></i></li>
                    <li><i class="fa fa-twitch"></i></li>
                    <li><i class="fa fa-twitter"></i></li>
                    <li><i class="fa fa-twitter-square"></i></li>
                    <li><i class="fa fa-usb"></i></li>
                    <li><i class="fa fa-viacoin"></i></li>
                    <li><i class="fa fa-viadeo"></i></li>
                    <li><i class="fa fa-viadeo-square"></i></li>
                    <li><i class="fa fa-vimeo"></i></li>
                    <li><i class="fa fa-vimeo-square"></i></li>
                    <li><i class="fa fa-vine"></i></li>
                    <li><i class="fa fa-vk"></i></li>
                    <li><i class="fa fa-wechat"></i></li>
                    <li><i class="fa fa-weibo"></i></li>
                    <li><i class="fa fa-weixin"></i></li>
                    <li><i class="fa fa-whatsapp"></i></li>
                    <li><i class="fa fa-wikipedia-w"></i></li>
                    <li><i class="fa fa-windows"></i></li>
                    <li><i class="fa fa-wordpress"></i></li>
                    <li><i class="fa fa-wpbeginner"></i></li>
                    <li><i class="fa fa-wpforms"></i></li>
                    <li><i class="fa fa-xing"></i></li>
                    <li><i class="fa fa-xing-square"></i></li>
                    <li><i class="fa fa-y-combinator"></i></li>
                    <li><i class="fa fa-y-combinator-square"></i></li>
                    <li><i class="fa fa-yahoo"></i></li>
                    <li><i class="fa fa-yc"></i></li>
                    <li><i class="fa fa-yc-square"></i></li>
                    <li><i class="fa fa-yelp"></i></li>
                    <li><i class="fa fa-yoast"></i></li>
                    <li><i class="fa fa-youtube"></i></li>
                    <li><i class="fa fa-youtube-play"></i></li>
                    <li><i class="fa fa-youtube-square"></i></li>
                    <h3 class="text-block  mt-5 mb-4"><strong>Medical Icons</strong></h3>
                    <li><i class="fa fa-ambulance"></i></li>
                    <li><i class="fa fa-h-square"></i></li>
                    <li><i class="fa fa-heart"></i></li>
                    <li><i class="fa fa-heart-o"></i></li>
                    <li><i class="fa fa-heartbeat"></i></li>
                    <li><i class="fa fa-hospital-o"></i></li>
                    <li><i class="fa fa-medkit"></i></li>
                    <li><i class="fa fa-plus-square"></i></li>
                    <li><i class="fa fa-stethoscope"></i></li>
                    <li><i class="fa fa-user-md"></i></li>
                    <li><i class="fa fa-wheelchair"></i></li>
                </ul>
            </div>
        </div>
    </div>
</section>
<!-- END: icons/fontawesome -->
